import {
    RiAddFill,
    RiArrowDownSLine,
    RiArrowRightSLine,
    RiArrowUpSLine,
    RiCheckboxBlankCircleLine,
    RiCheckboxCircleFill,
    RiPriceTag3Line, RiSubtractFill,
} from "@remixicon/react";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { DashboardGroupBy, DashboardView } from "../../../../__generated__/api";
import { useTicketState } from "../../../../contexts/ticket-state/TicketState";
import { TicketColumnGroup, TicketItem } from "../../../../contexts/ticket-state";
import Button from "../../../theme/button/Button";
import Card, { CardFields } from "../card/Card";
import Styles from "./ColumnGroup.module.scss";

export interface ColumnGroupProps {
    group: TicketColumnGroup;
    draggingItem: TicketItem | undefined;
}
export default function ColumnGroup({
    group,
    draggingItem,
}: ColumnGroupProps) {
    const ticketContext = useTicketState();

    const view = ticketContext.currentDashboard?.settings?.view ?? DashboardView.Kanban;
    const groupBy = ticketContext.currentDashboard?.settings?.groupBy ?? DashboardGroupBy.NoGroup;

    const [shouldDisplay, setShouldDisplay] = group.useDisplayState();
    const groupProperties = group.group;

    const [tickets, setTickets] = useState(group.tickets);
    useEffect(() => {
        setTickets(group.tickets);
    }, [group.tickets]);

    const selectedFields = view === DashboardView.Compact
        ? new Set(ticketContext.currentDashboard?.settings?.fieldIds ?? Object.values(CardFields))
        : new Set();

    const checkedCount = tickets.count(ticket => ticket.isChecked);
    return (
        <div className={classNames(Styles["column-group"], Styles[`column-group-${view?.toLowerCase()}`])}>
            {groupBy !== DashboardGroupBy.NoGroup && (
                <Button
                    variant="none"
                    className={classNames("column-group-header")}
                    onClick={() => setShouldDisplay(!shouldDisplay)}
                >
                    <div className={classNames("column-group-description", "d-flex", "gap3-1")}>
                        <Button
                            prefixIcon={shouldDisplay ? <RiArrowUpSLine /> : <RiArrowRightSLine />}
                            variant="none"
                            size="small"
                            className="column-group-expaner"
                        />
                        <div className="column-group-image">
                            {groupProperties?.icon}
                        </div>
                        <div className="flex-grow-1 column-group-text">
                            <div className="column-group-title">
                                {groupProperties?.title}
                            </div>
                            {groupProperties?.subtitle && (
                                <div className="column-group-subtitle">
                                    {groupProperties.subtitle}
                                </div>
                            )}

                        </div>

                        <Button
                            variant="none"
                            className="column-group-minimize"
                            prefixIcon={shouldDisplay ? <RiSubtractFill /> : <RiAddFill />}
                        />
                    </div>
                    <div className="ticket-count m3y-1 text-start">
                        <RiPriceTag3Line />
                        {" "}
                        {group.tickets.length}
                        {" "}
                        Tickets
                    </div>
                </Button>
            )}

            {shouldDisplay && (
                <div className="column-cards column-expanded">
                    {view === DashboardView.Compact ? (
                        <table className="cards-table">
                            <thead>
                                <tr>
                                    <th>
                                        {checkedCount > 0 && (
                                            <Button
                                                className={Styles["card-selector"]}
                                                variant="none"
                                                size="small"
                                                prefixIcon={checkedCount === tickets.length
                                                    ? <RiCheckboxCircleFill />
                                                    : <RiCheckboxBlankCircleLine />}
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    event.preventDefault();
                                                    const shouldCheck = checkedCount !== tickets.length;
                                                    tickets.forEach(ticket => ticket.setIsChecked(shouldCheck));
                                                }}
                                            />
                                        )}

                                    </th>
                                    <th>Number</th>
                                    {selectedFields.has(CardFields.SLA) && (
                                        <th>SLA</th>
                                    )}
                                    {selectedFields.has(CardFields.SUBJECT) && (
                                        <th>Subject</th>
                                    )}
                                    {selectedFields.has(CardFields.LAST_REPLY_MESSAGE) && (
                                        <th>Last Message </th>
                                    )}
                                    {selectedFields.has(CardFields.PRIORITY) && (
                                        <th>Priority </th>
                                    )}
                                    {selectedFields.has(CardFields.REQUEST_TYPE) && (
                                        <th>Request Type </th>
                                    )}
                                    {selectedFields.has(CardFields.QUEUE_ID) && (
                                        <th>Queue</th>
                                    )}
                                    {selectedFields.has(CardFields.TICKET_SOURCE) && (
                                        <th>Source </th>
                                    )}
                                    {selectedFields.has(CardFields.ASSIGNEE_ID) && (
                                        <th>Assignee </th>
                                    )}
                                    {selectedFields.has(CardFields.CREATED_DATE) && (
                                        <th>Date Created </th>
                                    )}
                                    {selectedFields.has(CardFields.REPLY_COUNT) && (
                                        <th># of Replies </th>
                                    )}
                                    {selectedFields.has(CardFields.LAST_REPLY_DATE) && (
                                        <th>Last Reply</th>
                                    )}
                                    {selectedFields.has(CardFields.REQUESTER_ID) && (
                                        <th>Requester</th>
                                    )}

                                </tr>
                            </thead>
                            <tbody>
                                {tickets.map(ticket => (
                                    <Card key={ticket.chat.id} ticketItem={ticket} isHidden={draggingItem === ticket} />
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        tickets.map(ticket => (
                            <Card key={ticket.chat.id} ticketItem={ticket} isHidden={draggingItem === ticket} />
                        ))
                    )}

                </div>
            )}

        </div>
    );
}
